import { Icon } from '../Icon';
import { IconMap } from '../IconMap';

interface SearchBarProps {
  placeholder: string;
  value?: string;
  iconSize?: number;
  onChange?: (value: string) => void;
  onSubmit?: () => void;
  iconRight?: keyof typeof IconMap;
}

export const SearchBar = ({
  placeholder,
  iconSize = 16,
  value = '',
  onChange,
  onSubmit,
  iconRight,
}: SearchBarProps) => {
  return (
    <div className="relative max-w-[488px]">
      <input
        type="text"
        placeholder={placeholder}
        className="border border-secondary-100 font-body placeholder-font-[400] placeholder-text-400 placeholder-font-[16px] rounded-md px-3 py-2 w-full pr-10 h-12"
        {...(onChange
          ? {
              value,
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value),
            }
          : {})}
      />

      {iconRight && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer" onClick={onSubmit}>
          <Icon name={iconRight} size={iconSize} />
        </div>
      )}
    </div>
  );
};
